import React, { useState } from 'react';
import styles from '../Flat.module.scss';
import RoomDdy from '../../../../../components/ui/RoomDdy/RoomDdy';
import { texts } from '../../../../../constants/texts';
import WithModalRoomDdy from '../../../../../components/ui/WithModalRoomDdy/WithModalRoomDdy';

const FlatRoomDdy = () => {
  const [visibleForm, setVisibleForm] = useState(false);
  const onClickClose = () => setVisibleForm(false);
  const onClicOpen = () => setVisibleForm(true);

  return (
    <>
      <RoomDdy
        className={styles.grow}
        title={texts.flatRoomDdy}
        openForm={onClicOpen}
      />
      <WithModalRoomDdy
        visible={visibleForm}
        onClickClose={onClickClose}
      />
    </>
  );
};

export default FlatRoomDdy;
